(() => {
  if (window.g6ProductHeaderReady) return;
  window.g6ProductHeaderReady = true;
  document.addEventListener('cart:update', async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-g6-cart-count]').forEach(node => { node.textContent = cart.item_count; });
    } catch {}
  });
})();
